import { PaginatorModel } from "model/utilModels/PaginatorModel";

export class InvoiceManagementModel extends PaginatorModel {
  invoiceId: string;
  fromCompanyId: string;
  fromCompanyName: string;
  toCompanyId: string;
  toCompanyName: string;
  subject: string;
  uploadedInvoiceFile: any;
  uploadedInvoice: string;
  status: string;
  uploadingDate: string;
  amount: string;
  currency: string;
  bankId: string;
  paidDate: string;
  dueDate: string;

  constructor() {
    super();
    this.invoiceId = "";
    this.fromCompanyId = "";
    this.fromCompanyName = "";
    this.toCompanyId="";
    this.toCompanyName="";
    this.status="";
    this.subject = "";
    this.uploadedInvoiceFile = "";
    this.uploadedInvoice = "";
    this.uploadingDate ="";
    this.amount="";
    this.currency="";
    this.bankId = "";
    this.paidDate = "";
    this.dueDate = "";
  }
}